import { decideError, CustomErrorType } from '@flexteam/error';

function handleCustomError(error) {
  const [errorType, httpError] = decideError(error);
  let isHandled = false;
  switch (errorType) {
    case CustomErrorType.RouteChangeCanceled: {
      isHandled = true;
      break;
    }
  }
  return { isHandled, errorType, httpError };
}

export { handleCustomError };
//# sourceMappingURL=utils.mjs.map
